import { useParams } from "react-router-dom";
import "../../../i18n/i18n";

export const SummaryTab = () => {
  const params = useParams();

  if (params.tab !== "summary") {
    return null;
  }

  return <></>;
};
